import { enableProdMode, inject, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import "hammerjs";
import { Platform } from "@ionic/angular";
import { register as registerSwiperElements } from "swiper/element";

// Defines the <swiper-container> and <swiper-slide> web components
registerSwiperElements();

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err) => console.error(err));
